import { Static } from "@bizform/type/decorator/Static.decorator";
import { ComponentLayoutStatic } from "@bizform/type/model/template/ComponentLayout.model";
import { PluginType } from "@bizform/type/model/model/Plugin.model";
import { DomAttribute } from "@bizform/type/model/dom/DomAttribute.model";

/**
 * 컴퍼넌트 레이아웃 템플릿
 * 라벨과 밸리데이션이 없음
 * 의 모양
 *
 * @since 0.0.1
 * @author Heungsoo Ham, Jongkwang Park
 * @class
 */
@Static<ComponentLayoutStatic>()
export class OnlyComponentElement {
    static readonly pluginType: string = PluginType.COMPONENTLAYOUT;
    static readonly uniqueId: string = "_B30ouiXDulMJ3FtOZfxcDkqTetzToOK";
    static readonly labelWidth: boolean = false;

    static init(): HTMLElement {
        const dom = document.createElement("div");
        dom.setAttribute(DomAttribute.COMPONENTCONTAINER, "");
        dom.innerHTML = `<div ${DomAttribute.COMPONENTELEMENT}></div>`;
        return dom;
    }
}
